import React, { forwardRef, useImperativeHandle } from 'react';
import ViewClientInfo from '../ViewClientInfo';
import ClientCreationWrapper from '../../HOC/ClientCreationWrapper';
import { versionExtract } from '../../Utilities/HelperMethods';

const PreviewClientInfo = ({
  client,
  selectedVersionInfo,
  versionData,
  isLoading,
  state,
  productLabel,
  planTypeLabel,
}) => {
  return (
    <ViewClientInfo
      data={client}
      versionInfo={selectedVersionInfo}
      versionData={versionData}
      isLoading={isLoading}
      state={state}
      productLabel={productLabel}
      planTypeLabel={planTypeLabel}
    />
  );
};
const WithWrapper = ClientCreationWrapper(PreviewClientInfo);
const PreviewInfo = forwardRef((props, ref) => {
  const { data } = props;
  const getClientInfo = () => {
    return {
      ...data,
      createdVersions: [
        {
          ...data?.createdVersions?.[0],
          illustrationData: versionExtract(data?.createdVersions?.[0]?.illustrationData),
        },
      ],
    };
  };
  useImperativeHandle(ref, () => {
    return {
      getClientInfo: () => getClientInfo(),
    };
  }, []);
  return (
    <WithWrapper
      client={data}
      versionData={versionExtract(data?.createdVersions?.[0]?.illustrationData)}
      selectedVersionInfo={data?.createdVersions?.[0]}
    />
  );
});
export default PreviewInfo;
